import { staticRoutes } from 'api/apiRoutes';
import { axiosInstance } from 'api/axiosInstance';

export const unsubscribeRequest = async (subid: string, email: string) => (
  await axiosInstance().post<{ message: string }>(staticRoutes.unsubscribe(), { subid, email })
).data;
